function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#202020;}\n\t.st1{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Other_stuff"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  y: 588.2,
  className: "st0",
  width: 1480,
  height: 3.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1461.8,310 1458.2,310 1458.2,81.8 981.8,81.8 981.8,310 978.2,310 978.2,78.2 1461.8,78.2  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1461.8,590 1458.2,590 1458.2,311.8 979.8,311.8 979.6,311.7 741.8,252.2 741.8,312.2 739.6,311.7  501.8,252.2 501.8,312.2 499.6,311.7 261.8,252.2 261.8,311.8 21.8,311.8 21.8,590 18.2,590 18.2,308.2 258.2,308.2 258.2,247.8  260.4,248.3 498.2,307.8 498.2,247.8 500.4,248.3 738.2,307.8 738.2,247.8 740.4,248.3 980.2,308.2 1461.8,308.2  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 965,
  y: 80,
  className: "st1",
  width: 510,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1476.8,101.8H963.2V78.2h513.5v23.6H1476.8z M966.8,98.2h506.5V81.8H966.8V98.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M331.8,471.8h-43.5v-43.5h43.5V471.8z M291.8,468.2h36.5v-36.5h-36.5V468.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M324.7,481.8h-29.4c-3.9,0-7.1-3.2-7.1-7.1v-49.4c0-3.9,3.2-7.1,7.1-7.1h29.4c3.9,0,7.1,3.2,7.1,7.1v49.4 C331.8,478.6,328.6,481.8,324.7,481.8z M295.3,421.8c-2,0-3.6,1.6-3.6,3.6v49.4c0,2,1.6,3.6,3.6,3.6h29.4c2,0,3.6-1.6,3.6-3.6 v-49.4c0-2-1.6-3.6-3.6-3.6H295.3z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M166.8,470h-3.5c0-12.8-10.4-23.2-23.2-23.2s-23.2,10.4-23.2,23.2h-3.5c0-14.8,12-26.8,26.8-26.8 S166.8,455.2,166.8,470z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 138.2,
  y: 520,
  className: "st0",
  width: 3.5,
  height: 10
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M165,591.8H58.2V500c0-8.5,3.3-16.5,9.3-22.5s14-9.3,22.5-9.3h35v3.5H90c-7.5,0-14.6,2.9-20,8.3 s-8.3,12.4-8.3,20v88.2H165V591.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "181.8,490 178.2,490 178.2,471.8 155,471.8 155,468.2 181.8,468.2  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "170.7,511.8 155,511.8 155,508.2 169.3,508.2 178.2,499.3 178.2,490 181.8,490 181.8,500.7  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M191.8,591.8H165v-3.5h23.2V570c0-4.9-1.9-9.5-5.3-12.9c-3.4-3.4-8-5.3-12.9-5.3H98.2v-43.5H125v3.5h-23.2 v36.5H170c5.8,0,11.3,2.3,15.4,6.4c4.1,4.1,6.4,9.6,6.4,15.4L191.8,591.8L191.8,591.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "131.8,590 128.2,590 128.2,565.7 113.8,551.2 116.2,548.8 131.8,564.3  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "166.8,591.8 130,591.8 130,588.2 163.2,588.2 163.2,565.7 148.8,551.2 151.2,548.8 166.8,564.3  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 130,
  y: 563.2,
  className: "st0",
  width: 35,
  height: 3.5
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M145.7,521.8h-11.5l-11-11V470c0-9.2,7.5-16.8,16.8-16.8s16.8,7.5,16.8,16.8v40.7L145.7,521.8z M135.7,518.2 h8.5l9-9V470c0-7.3-5.9-13.2-13.2-13.2s-13.2,5.9-13.2,13.2v39.3L135.7,518.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 125,
  y: 473.2,
  className: "st0",
  width: 30,
  height: 3.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 125,
  y: 503.2,
  className: "st0",
  width: 30,
  height: 3.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M146.8,551.8h-13.5v-13.5h7.5l6,6V551.8z M136.8,548.2h6.5v-2.5l-4-4h-2.5V548.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 1501.9,
  y: 352.2,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 170.1521 1175.1581)",
  className: "st0",
  width: 3.5,
  height: 60
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1510.7,420 1477.1,386.5 1477.1,371.6 1480.6,371.6 1480.6,385 1510.7,415.1 1520.1,405.7  1522.6,408.2  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1489.5,404.5c-2.2,0-4.2-0.8-5.7-2.4c-1.5-1.5-2.4-3.6-2.4-5.7c0-2.2,0.8-4.2,2.4-5.7l2.5,2.5 c-1.8,1.8-1.8,4.7,0,6.5s4.7,1.8,6.5,0l2.5,2.5C1493.7,403.6,1491.7,404.5,1489.5,404.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1514.2,407 1528.4,407 1482.4,361 1475.4,368.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1532.6,408.7h-19.1l-40.6-40.6l9.5-9.5L1532.6,408.7z M1515,405.2h9.2l-41.7-41.7l-4.6,4.6L1515,405.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1472.1,416.2 1460,416.2 1460,412.7 1470.6,412.7 1483.8,399.6 1486.2,402.1  "
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 740,
  y: 283.2,
  className: "st0",
  width: 140,
  height: 3.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M310,501.8c-28.5,0-51.8-23.2-51.8-51.8s23.2-51.8,51.8-51.8s51.8,23.2,51.8,51.8S338.5,501.8,310,501.8z  M310,401.8c-26.6,0-48.2,21.6-48.2,48.2s21.6,48.2,48.2,48.2s48.2-21.6,48.2-48.2S336.6,401.8,310,401.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 1260,
  y: 588.2,
  className: "st0",
  width: 120,
  height: 3.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1055,501.8c-28.5,0-51.8-23.2-51.8-51.8s23.2-51.8,51.8-51.8s51.8,23.2,51.8,51.8S1083.5,501.8,1055,501.8z  M1055,401.8c-26.6,0-48.2,21.6-48.2,48.2s21.6,48.2,48.2,48.2s48.2-21.6,48.2-48.2S1081.6,401.8,1055,401.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1081.8,479.2h-53.5v-32.3l3.7-5V433l-3.7-5v-0.6c0-3.7,3-6.8,6.8-6.8h6l14,23.3l14-23.3h6 c3.7,0,6.8,3,6.8,6.8v0.6l-3.7,5v8.9l3.7,5v32.3H1081.8z M1031.8,475.8h46.5v-27.7l-3.7-5V432l3.6-4.9c-0.2-1.5-1.6-2.7-3.2-2.7 h-4l-16,26.7l-16-26.7h-4c-1.6,0-3,1.2-3.2,2.7l3.6,4.9v11.1l-3.7,5L1031.8,475.8L1031.8,475.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 1041.9,
  y: 422.8,
  className: "st0",
  width: 26.2,
  height: 3.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 1053.2,
  y: 447.5,
  className: "st0",
  width: 3.5,
  height: 30
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 1030,
  y: 455.8,
  className: "st0",
  width: 50,
  height: 3.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 1030,
  y: 465.8,
  className: "st0",
  width: 50,
  height: 3.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 1063.2,
  y: 431.5,
  className: "st0",
  width: 3.5,
  height: 26
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 1043.2,
  y: 431.5,
  className: "st0",
  width: 3.5,
  height: 26
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 133.2,
  y: 475,
  className: "st0",
  width: 3.5,
  height: 30
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 143.2,
  y: 475,
  className: "st0",
  width: 3.5,
  height: 30
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 108.2,
  y: 510,
  className: "st0",
  width: 3.5,
  height: 40
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M161.8,430h-3.5c0-1.8-1.5-3.2-3.2-3.2v-3.5C158.7,423.2,161.8,426.3,161.8,430z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M171.8,430h-3.5c0-7.3-5.9-13.2-13.2-13.2v-3.5C164.2,413.2,171.8,420.8,171.8,430z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M181.8,430h-3.5c0-12.8-10.4-23.2-23.2-23.2v-3.5C169.8,403.2,181.8,415.2,181.8,430z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1516.8,370h-3.5c0-1.8-1.5-3.2-3.2-3.2v-3.5C1513.7,363.2,1516.8,366.3,1516.8,370z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1526.8,370h-3.5c0-7.3-5.9-13.2-13.2-13.2v-3.5C1519.2,353.2,1526.8,360.8,1526.8,370z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1536.8,370h-3.5c0-12.8-10.4-23.2-23.2-23.2v-3.5C1524.8,343.2,1536.8,355.2,1536.8,370z"
}))));

var SvgFactory = function SvgFactory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1550 595",
    style: {
      enableBackground: "new 0 0 1550 595"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFactory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/factory.f8bb5eab.svg";
export { ForwardRef as ReactComponent };